import { FontConfig } from "../types"

export const BODY_3XL_CONFIG: FontConfig = {
  title: "BODY/3xl",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 20, tw: "text-[18px]" },
    lineHeight: { px: 28, tw: "leading-[28px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 24, tw: "text-[24px]" },
    lineHeight: { px: 30, tw: "leading-[30px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 32, tw: "text-[32px]" },
    lineHeight: { px: 39, tw: "leading-[39px]" },
  },
}
